
import { sendRequest } from "../../hooks/requests/useRequest";


export async function saveUpdateConfiguration({
    id_user, permissions
}) {
    const body = {
        id_user,
        permissions
    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Users/UpdateConfiguration"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return {
            code: response?.code,
            data: response?.data,
        }
    else if (response.code === 500)
        return {
            code: response?.code,
            data: response?.data,
        }
    else
        return response.data;

}